export const DATE_FORMAT_DD_MM_YYYY = 'DD-MM-YYYY'
export const DATE_DISPLAY_FORMAT_DD_MON_YYYY = 'DD MMM YYYY'

export const PRODUCT_ID = 1